export class RateCurve {
	
	rateId: number;
	country: string;
	months: number;
	rateName: string;
}